import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useHasFiltersApplied, useSearchActions, useSearchResults } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefine: () => void;
	}
>;

export function useClearAllFilters(): Result {
	const results = useSearchResults();
	const actions = useSearchActions();
	const hasFilters = useHasFiltersApplied();
	const track = useTracking();

	return {
		data: {
			hideButton: !hasFilters,
		},
		actions: {
			clearRefine: useCallback(() => {
				actions.clearAllFilters();
				void track('search', { q: results.query || '', context: 'clear_filters_modal_button' });
			}, [actions, results.query, track]),
		},
	};
}
